import React, { FC, ReactElement } from 'react';
import MUITooltip, { TooltipProps as MUITooltipProps } from '@mui/material/Tooltip';

export interface TooltipPropsType extends MUITooltipProps {
    children: ReactElement;
}

const Tooltip: FC<TooltipPropsType> = (props) => {
    if (!props.title) {
        return props.children;
    }
    return <MUITooltip title={props.title}>{props.children}</MUITooltip>;
};

export default Tooltip;
